"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getChartTypeDescriptionSelector = void 0;
const get_goal_spec_1 = require("./get_goal_spec");
const create_selector_1 = require("../../../../state/create_selector");
exports.getChartTypeDescriptionSelector = (0, create_selector_1.createCustomCachedSelector)([get_goal_spec_1.getGoalSpecSelector], (spec) => {
    return `${spec?.subtype ?? 'goal'} chart`;
});
//# sourceMappingURL=get_chart_type_description.js.map